<div class="page-content fade-in-up" *ngIf="list_flag">
    <div class="row">
        <div class="col-lg-12 col-md-12">

            <div class="ibox" *ngIf="!view_book_flag && !view_book_klm_flag">
                <div class="ibox-head">
                    <div class="ibox-title">
                        Kalyan Mandap bookings
                    </div>
                </div>
                <div class="ibox-body">
                    <ul class="nav nav-tabs tabs-line" *ngIf="!view_book_flag && !view_book_klm_flag">
                        <li class="nav-item">
                            <a class="nav-link active" href="#tab-1" data-toggle="tab" (click)="getbookingdata('NO')"><i
                                    class="ti-bar-chart"></i>
                                New Booking Request</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" href="#tab-2" data-toggle="tab" (click)="getbookingdata('YES')"><i
                                    class="ti-bar-chart"></i>
                                Employee Bookings</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" href="#tab-3" data-toggle="tab"><i class="ti-bar-chart"></i>
                                Pending Refund</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" href="#tab-4" data-toggle="tab"><i class="ti-bar-chart"></i>
                                Completed Bookings</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" href="#tab-5" data-toggle="tab"><i class="ti-bar-chart"></i>
                                Cancelled Bookings</a>
                        </li>
                    </ul>
                    <br>
                    <div class="tab-content">

                        <div class="tab-pane fade show active" id="tab-1"
                            *ngIf="!view_book_flag && !view_book_klm_flag">
                            <div *ngIf="list_flag">
                                <div class="d-flex justify-content-between mb-3">
                                    <div class="filter d-flex">
                                        <i class="fa fa-search search_icon" aria-hidden="true"></i>
                                        <input class="input-filter" placeholder="Search by Name, Letter and Number"
                                            (keyup)="applyFilter($any($event.target).value)">
                                    </div>

                                    <div class="export_btn">
                                        <button class="btn_export" (click)="export()">Export</button>
                                    </div>

                                </div>
                                <div class="example-container mt-2" style="text-size-adjust: 2;">
                                    <table mat-table [dataSource]="datasource" matSort>
                                        <ng-container matColumnDef="si_no">
                                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>SI.NO
                                            </th>
                                            <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                                {{element.new_index}}</td>
                                        </ng-container>
                                        <ng-container matColumnDef="applicant_name">
                                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>
                                                Applicant Name</th>
                                            <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                                {{element.party_name}}
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="kalyan_mandap_name">
                                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>Kalyan
                                                mandap Nmae</th>
                                            <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                                {{element.klm_name}}
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="address">
                                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>Address
                                            </th>
                                            <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                                {{element.street_name}}
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="booking_date">
                                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>Booking
                                                Date</th>
                                            <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                                {{element['check_in_time'] | date:'YYYY-MM-dd'}}</td>
                                        </ng-container>
                                        <ng-container matColumnDef="check_out_date">
                                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>Check
                                                Out Date</th>
                                            <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                                {{element.check_out_time | date:'YYYY-MM-dd'}}</td>
                                        </ng-container>
                                        <ng-container matColumnDef="total_payble_amt">
                                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>Amount
                                            </th>
                                            <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                                {{element.total_payble_amt}}</td>
                                        </ng-container>


                                        <ng-container matColumnDef="action">
                                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>Action
                                            </th>
                                            <td mat-cell flex-stretch *matCellDef="let element">
                                                <div style="display: flex; align-items: center;">
                                                    <i class="fa fa-eye hhh" (click)="open_application(element)"
                                                        aria-hidden="true"></i>&nbsp;&nbsp;&nbsp;&nbsp;
                                                    <div class="showonhover">
                                                        <i class="fa fa-ellipsis-v hhh"
                                                            (click)="toggleHoverText($event)" aria-hidden="true"></i>
                                                        <span class="hovertext">
                                                            <ul>
                                                                <li class="hh_tt" (click)="view_booking_dtls(element)">
                                                                    <h6>View Booking Details</h6>
                                                                </li>
                                                                <li class="hh_tt" (click)="view_kalyan_mandap(element)">
                                                                    <h6>View Kalyan mandap </h6>
                                                                </li>
                                                                <li class="hh_tt" (click)="open_application(element)">
                                                                    <h6>View Invoice </h6>
                                                                </li>
                                                                <!-- <li class="hh_tt" (click)="open_application(element)">
                                                                                    <h6>Approved Bookings </h6>
                                                                                </li>
                                                                                <li class="hh_tt" (click)="open_application(element)">
                                                                                    <h6>Reject Bookings </h6>
                                                                                </li> -->
                                                                <!-- <li class="hh_tt" (click)="view_license(element)">
                                                                                    <h6>View License</h6>
                                                                                </li>
                                                                                <li class="hh_tt" (click)="view_invoice(element)">
                                                                                    <h6>View Invoice</h6>
                                                                                </li>
                                                                                <li class="hh_tt" (click)="view_idcard(element)">
                                                                                    <h6>View Id Card</h6>
                                                                                </li>
                                                                                <li class="hh_tt" (click)="qr_view(element,$event)">
                                                                                    <h6>View QR Code</h6>
                                                                                </li> -->
                                                            </ul>
                                                        </span>
                                                    </div>
                                                </div>
                                            </td>
                                        </ng-container>
                                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                                    </table>
                                    <mat-paginator #paginator0 [pageSizeOptions]="[10, 20]"
                                        showFirstLastButtons></mat-paginator>
                                </div>
                            </div>
                        </div>
                        <div class="tab-pane fade" id="tab-2">
                            <div *ngIf="list_flag">
                                <div class="d-flex justify-content-between mb-3">
                                    <div class="filter d-flex">
                                        <i class="fa fa-search search_icon" aria-hidden="true"></i>
                                        <input class="input-filter" placeholder="Search by Name, Letter and Number"
                                            (keyup)="applyFilter($any($event.target).value)">
                                    </div>

                                    <div class="export_btn">
                                        <button class="btn_export" (click)="export()">Export</button>
                                    </div>

                                </div>
                                <div class="example-container mt-2" style="text-size-adjust: 2;">
                                    <table mat-table [dataSource]="datasource" matSort>
                                        <ng-container matColumnDef="si_no">
                                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>SI.NO
                                            </th>
                                            <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                                {{element.new_index}}</td>
                                        </ng-container>
                                        <ng-container matColumnDef="applicant_name">
                                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>
                                                Applicant Name</th>
                                            <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                                {{element.party_name}}
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="kota">
                                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>
                                                KOTA</th>
                                            <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                                {{element.kota}}
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="emp_id">
                                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>
                                                Employee ID </th>
                                            <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                                <!-- {{element.kota}}/ -->
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="kalyan_mandap_name">
                                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>Kalyan
                                                mandap Nmae</th>
                                            <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                                {{element.party_name}}
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="address">
                                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>Address
                                            </th>
                                            <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                                {{element.street_name}}
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="booking_date">
                                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>Booking
                                                Date</th>
                                            <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                                {{element['check_in_time'] | date:'YYYY-MM-dd'}}</td>
                                        </ng-container>
                                        <ng-container matColumnDef="check_out_date">
                                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>Check
                                                Out Date</th>
                                            <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                                {{element.check_out_time | date:'YYYY-MM-dd'}}</td>
                                        </ng-container>
                                        <ng-container matColumnDef="total_payble_amt">
                                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>Amount
                                            </th>
                                            <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                                {{element.total_payble_amt}}</td>
                                        </ng-container>
                                        <ng-container matColumnDef="status">
                                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>
                                                Status</th>
                                            <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                                {{element.arr_status_code}}
                                            </td>
                                        </ng-container>


                                        <ng-container matColumnDef="action">
                                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>Action
                                            </th>
                                            <td mat-cell flex-stretch *matCellDef="let element">
                                                <div style="display: flex; align-items: center;">
                                                    <i class="fa fa-eye hhh" (click)="open_application(element)"
                                                        aria-hidden="true"></i>&nbsp;&nbsp;&nbsp;&nbsp;
                                                    <div class="showonhover">
                                                        <i class="fa fa-ellipsis-v hhh"
                                                            (click)="toggleHoverText($event)" aria-hidden="true"></i>
                                                        <span class="hovertext">
                                                            <ul>
                                                                <li class="hh_tt" (click)="view_booking_dtls(element)">
                                                                    <h6>View Booking Details</h6>
                                                                </li>
                                                                <!-- <li class="hh_tt" (click)="view_kalyan_mandap(element)">
                                                                    <h6>View Kalyan mandap </h6>
                                                                </li> -->
                                                                <li class="hh_tt" (click)="open_application(element)">
                                                                    <h6>View Invoice </h6>
                                                                </li>
                                                                <!-- <li class="hh_tt" (click)="open_application(element)">
                                                                                    <h6>Approved Bookings </h6>
                                                                                </li>
                                                                                <li class="hh_tt" (click)="open_application(element)">
                                                                                    <h6>Reject Bookings </h6>
                                                                                </li> -->
                                                                <!-- <li class="hh_tt" (click)="view_license(element)">
                                                                                    <h6>View License</h6>
                                                                                </li>
                                                                                <li class="hh_tt" (click)="view_invoice(element)">
                                                                                    <h6>View Invoice</h6>
                                                                                </li>
                                                                                <li class="hh_tt" (click)="view_idcard(element)">
                                                                                    <h6>View Id Card</h6>
                                                                                </li>
                                                                                <li class="hh_tt" (click)="qr_view(element,$event)">
                                                                                    <h6>View QR Code</h6>
                                                                                </li> -->
                                                            </ul>
                                                        </span>
                                                    </div>
                                                </div>
                                            </td>
                                        </ng-container>
                                        <tr mat-header-row *matHeaderRowDef="displayedmunciplEmpColumns"></tr>
                                        <tr mat-row *matRowDef="let row; columns: displayedmunciplEmpColumns;"></tr>
                                    </table>
                                    <mat-paginator #paginator0 [pageSizeOptions]="[10, 20]"
                                        showFirstLastButtons></mat-paginator>
                                </div>
                            </div>
                        </div>
                        <div class="tab-pane fade" id="tab-3">


                        </div>




                    </div>

                </div>

            </div>


            <div class="row" *ngIf="view_book_flag">
                <div class="row">
                    <br>
                    <div class="col-10 text-left">

                        <h5 style="font-weight:bold;margin-left: 22px;">
                            Booking Overview
                        </h5>
                    </div>
                    <div class="col-2 text-right">
                        <h6 class=" btn-link" style="color:blue" (click)="goback_to_list()"> Back</h6>

                    </div>
                    <br>

                    <div class="col-sm-3">
                        <div class="card" style="margin-left: 22px;">
                            <div class="card-body">
                                <h5 class="card-title">Booked By</h5>
                                <hr>
                                <div class="row">
                                    <div class="col-6 text-left">
                                        <i class="fa fa-user" aria-hidden="true"></i> &nbsp; Name
                                    </div>
                                    <div class="col-6 text-right">
                                        {{booking_data[0]['party_name']}}
                                    </div>
                                </div>

                                <hr>
                                <div class="row mt-1">
                                    <div class="col-6 text-left">
                                        <i class="fa fa-id-card-o" aria-hidden="true"></i>
                                        &nbsp;
                                        Reservation
                                    </div>
                                    <div class="col-6 text-right">
                                        {{booking_data[0]['is_muncipl_emp']}}
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="col-sm-3">
                        <div class="card">
                            <div class="card-body">
                                <h5 class="card-title">Contact Details</h5>
                                <hr>
                                <div class="row">
                                    <div class="col-4 text-left">
                                        <i class="fa fa-envelope" aria-hidden="true"></i> &nbsp; Email
                                    </div>
                                    <div class="col-8 text-right">
                                        {{booking_data[0]['email_id']}}
                                    </div>
                                </div>

                                <hr>
                                <div class="row mt-1">
                                    <div class="col-6 text-left">
                                        <i class="fa fa-mobile" aria-hidden="true"></i>
                                        &nbsp;
                                        Phone
                                    </div>
                                    <div class="col-6 text-right">
                                        {{booking_data[0]['mobile_no']}}
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="col-sm-3">
                        <div class="card">
                            <div class="card-body">
                                <h5 class="card-title">Booking Details</h5>
                                <hr>
                                <div class="row">
                                    <div class="col-6 text-left">
                                        <i class="fa fa-calendar-o" aria-hidden="true"></i> &nbsp; Order Date
                                    </div>
                                    <div class="col-6 text-right">
                                        {{booking_data[0]['pay_time'] | date: 'YYYY-MM-dd' }}
                                    </div>
                                </div>

                                <hr>
                                <div class="row mt-1">
                                    <div class="col-6 text-left">
                                        <i class="fa fa-credit-card" aria-hidden="true"></i>
                                        &nbsp;
                                        Payment Method
                                    </div>
                                    <div class="col-6 text-right">
                                        {{booking_data[0]['payment_method']}}
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="col-sm-3">
                        <div class="card">
                            <div class="card-body">
                                <h5 class="card-title">Documents</h5>
                                <hr>
                                <div class="row">
                                    <div class="col-6 text-left">
                                        <i class="fa fa-list-alt" aria-hidden="true"></i> &nbsp; Invoice
                                    </div>
                                    <div class="col-6 text-right">
                                        {{booking_data[0]['email_id']}}
                                    </div>
                                </div>

                                <hr>


                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mt-3">
                    <br>


                    <div class="col-sm-6">
                        <div class="card" style="margin-left: 22px;">
                            <div class="card-body">
                                <h5 class="card-title">Billing Address</h5>

                                <div class="row">

                                    <div class="col-8 text-left">
                                        {{booking_data[0]['street_name']}} , <br>
                                        {{booking_data[0]['party_state']}} ( {{booking_data[0]['party_pin_code']}} ) ,
                                        <br>
                                        {{booking_data[0]['party_city']}}
                                    </div>
                                    <div class="col-4"></div>
                                </div>




                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="card">
                            <div class="card-body">
                                <h5 class="card-title">Reservation Date</h5>
                                <!-- <hr> -->
                                <div class="row">
                                    <div class="col-8 ">

                                        {{booking_data[0]['check_in_time'] | date:'YYYY-MM-dd'}}


                                        <div class="row">
                                            <div class="col-12 text-left">
                                                Purpose of Booking

                                            </div>

                                        </div>

                                        <div class="row">
                                            <div class="col-12 text-left">
                                                {{booking_data[0]['purpose']}}

                                            </div>

                                        </div>

                                    </div>
                                    <div class="col-4">

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>



                <br>
                <br>
                <h5 style="font-weight:bold;margin-left: 22px;margin-top:15px">
                    Booking Details
                </h5>
                <br>
                <div class="row mt-3">
                    <div class="card" style="margin-left: 22px;">
                        <div class="card-body">
                            <h5 class="card-title"> Booking ID</h5>
                            <hr>

                            <div class="row mt-1">
                                <div class="col-2">
                                    <img [src]="imgURL1[0]" class="img-fluid" alt="Image {{imgURL1[0] }}" />
                                </div>
                                <div class="col-2 text-left">
                                    {{booking_data[0]['klm_name']}}
                                </div>
                                <div class="col-2">
                                    <label for="Opinion">Opinion</label>

                                </div>
                                <div class="col-1">
                                    <label for="zone">Zone</label>

                                </div>
                                <div class="col-1">

                                    <label for="Area"> Area</label>

                                </div>
                                <div class="col-2">

                                    <label for="location"> Location</label>


                                </div>
                                <div class="col-2">
                                    <label for="location"> Booking Price</label>


                                </div>
                            </div>
                            <div class="row ">
                                <div class="col-2">

                                </div>
                                <div class="col-2 text-left">

                                </div>
                                <div class="col-2">

                                    {{booking_data[0]['no_of_hall']}} Hall + {{booking_data[0]['no_of_room']}} Room

                                </div>
                                <div class="col-1">

                                    {{booking_data[0]['zone']}}

                                </div>
                                <div class="col-1">


                                    {{booking_data[0]['size']}}
                                </div>
                                <div class="col-2">


                                    {{booking_data[0]['km_street_name']}}

                                </div>
                                <div class="col-2">

                                    {{booking_data[0]['total_payble_amt']}}
                                </div>
                            </div>

                        </div>
                    </div>

                </div>

                <div class="row mt-1">
                    <div class="col-10"></div>
                    <div class="col-2 text-right">
                        <h6 class=" btn-link" style="color:red"> Cancel Booking</h6>
                        <!-- <button type="button" class="btn btn-link" style="color:red">Link</button> -->
                    </div>
                </div>

            </div>


            <div class=" mt-1" *ngIf="view_book_klm_flag">


                <div class="row pic_row">
                    <div class="col-xl-6">
                        <img [src]="imgURL1[0]" class="img-fluid" alt="Image {{imgURL1[0] }}" />
                    </div>
                    <div class="col-xl-6">
                        <div class="row">
                            <div class="col-lg-6">
                                <img [src]="imgURL1[1]" class="img-fluid1" alt="Image {{imgURL1[1] }}" />

                            </div>
                            <div class="col-lg-6">
                                <img [src]="imgURL1[2]" class="img-fluid1" alt="Image {{imgURL1[2] }}" />

                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-6">
                                <img [src]="imgURL1[3]" class="img-fluid1" alt="Image {{imgURL1[3] }}" />

                            </div>
                            <div class="col-lg-6">
                                <img [src]="imgURL1[4]" class="img-fluid1" alt="Image {{imgURL1[4] }}" />

                            </div>
                        </div>
                    </div>
                </div>

                <div class="row mt-1">
                    <div class="col-6">
                        <div class="card" style="margin-left: 22px;">
                            <div class="card-body">
                                <h5 class="card-title">

                                    {{booking_data[0]['klm_name']}}
                                </h5>

                                <div class="row">
                                    <div class="col-3">
                                        <img src="../../../assets/kalyan-mandap/klm_timing.png" alt="Avatar">
                                        &nbsp; &nbsp; <h6>{{booking_data[0]['booking_duration']}}</h6>

                                    </div>
                                    <div class="col-3">
                                        <img src="../../../assets/kalyan-mandap/person_icon.png" alt="Avatar">
                                        &nbsp; &nbsp; <h6>{{booking_data[0]['max_people']}}</h6>

                                    </div>
                                    <div class="col-6">
                                        <img src="../../../assets/kalyan-mandap/location_icon.png" alt="Avatar">
                                        <h6>{{booking_data[0]['km_street_name']}}</h6>

                                    </div>


                                </div>

                                <div class="row mt-1">
                                    <div class="col-12 text-left">
                                        <p>{{booking_data[0]['klm_desc']}}</p>
                                    </div>
                                </div>
                                <div class="row mt-1">
                                    <div class="col-12 text-left">

                                        <h5 style="font-weight: bold;"> Highlights of the Tour</h5>
                                    </div>
                                </div>
                                <div class="row mt-1">
                                    <div class="col-8 text-left">
                                        Size of Hall
                                    </div>
                                    <div class="col-4 text-right">
                                        <h6>{{booking_data[0]['size']}}</h6>

                                    </div>
                                </div>
                                <div class="row mt-1">
                                    <div class="col-8 text-left">
                                        Number Of Rooms
                                    </div>
                                    <div class="col-4 text-right">
                                        <h6>{{booking_data[0]['no_of_room']}}</h6>
                                    </div>
                                </div>
                                <div class="row mt-1">
                                    <div class="col-8 text-left">
                                        Size of Rooms
                                    </div>
                                    <div class="col-4 text-right">
                                        <h6>{{booking_data[0]['size']}}</h6>
                                    </div>
                                </div>
                                <div class="row mt-1">
                                    <div class="col-8 text-left">
                                        Size of Halls
                                    </div>
                                    <div class="col-4 text-right">
                                        <h6>{{booking_data[0]['size']}}</h6>
                                    </div>
                                </div>
                                <div class="row mt-1">
                                    <div class="col-8 text-left">
                                        No of AC Room
                                    </div>
                                    <div class="col-4 text-right">

                                    </div>
                                </div>
                                <!-- <div class="row mt-1">
                                <div class="col-8 text-left">
                                    Nearest Land Market
                                </div>
                                <div class="col-4 text-right">

                                </div>
                             </div> -->

                            </div>
                        </div>
                    </div>
                    <div class="col-6">

                    </div>
                </div>
                <!-- <div class="container mt-1" style="max-width: 1581px">
                    <div class="row header">
                        <div class="col-12 text-left">
                            <h5>{{booking_data[0]['klm_name']}}</h5>
                        </div>
                    </div>
            
                    <br>
            
                    <div class="row">
                        <div class="col-8">
                            <div class="row">
                                <div class="col-1 text-right">
                                    <img src="../../../assets/kalyan-mandap/klm_timing.png" alt="Avatar">
                                </div>
                                <div class="col-2 text-left">
                                </div>
                                <div class="col-1 text-right">
                                    <img src="../../../assets/kalyan-mandap/person_icon.png" alt="Avatar">
                                </div>
                                <div class="col-2 text-left">
                                    <h6>{{booking_data[0]['max_people']}}</h6>
                                </div>
                                <div class="col-1 text-right">
                                    <img src="../../../assets/kalyan-mandap/location_icon.png" alt="Avatar">
                                </div>
                                <div class="col-2 text-left">
                                    <h6>{{booking_data[0]['street_name']}}</h6>
                                </div>
                            </div>
            
            
                            <div class="row mt-1">
                                <div class="col-12 text-left">
                                    <p>{{booking_data[0]['klm_desc']}}</p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 text-left">
                                    <h5>Highlights of this Kalyan Mandap</h5>
                                </div>
                            </div>
            
            
                            <div class="row  mt-1">
                                <div class="col-8 text-left">
                                    Check-in Time
                                </div>
                                <div class="col-4 text-right">
                                    <h6>{{booking_data[0]['check_in_time']}}</h6>
                                </div>
                            </div>
                            <br>
                            <div class="row  mt-1">
                                <div class="col-8 text-left">
                                    Check-Out Time
                                </div>
                                <div class="col-4 text-right">
                                    <h6>{{booking_data[0]['check_out_time']}}</h6>
                                </div>
                            </div>
                            <br>
                            <div class="row  mt-1">
                                <div class="col-8 text-left">
                                    Size of Hall
                                </div>
                                <div class="col-4 text-right">
                                    <h6>{{booking_data[0]['size']}}</h6>
                                </div>
                            </div>
                            <br>
                            <div class="row  mt-1">
                                <div class="col-8 text-left">
                                    Number Of Rooms
                                </div>
                                <div class="col-4 text-right">
                                    <h6>{{booking_data[0]['no_of_room']}}</h6>
                                </div>
                            </div>
                            <br>
                            <div class="row  mt-1">
                                <div class="col-8 text-left">
                                    Size of Rooms
                                </div>
                                <div class="col-4 text-right">
                                    <h6>{{booking_data[0]['size']}}</h6>
                                </div>
                            </div>
                            <br>
                            <div class="row  mt-1">
                                <div class="col-8 text-left">
                                    Number of Halls
                                </div>
                                <div class="col-4 text-right">
                                    <h6>{{booking_data[0]['no_of_hall']}}</h6>
                                </div>
                            </div>
                            <br>
                            <div class="row  mt-1">
                                <div class="col-8 text-left">
                                    Size of Halls
                                </div>
                                <div class="col-4 text-right">
                                    <h6>{{booking_data[0]['size']}}</h6>
                                </div>
                            </div>
                            <br>
                            <div class="row  mt-1">
                                <div class="col-8 text-left">
                                    No of AC Room
                                </div>
                                <div class="col-4 text-right">
                                </div>
                            </div>
                            <br>
                            <div class="row  mt-1">
                                <div class="col-8 text-left">
                                    Nearest Land Market
                                </div>
                                <div class="col-4 text-right">
                                    <h6></h6>
                                </div>
                            </div>
                        </div>
                        <div class="col-4">
                            <div class="card">
                                <div class="card-body">
                                    <h5 class="card-title" style="text-align: center;">Book This Space</h5>
                                    <p style="text-align: center;">Reserve your ideal Space early for a hassle-free wedding season. Secure comfort and
                                        convenience!
                                    </p>
                                    <div class="form-group">
            
            
                                        <label for="purpose">Purpose<span style="color: #ff0000;">*</span></label>
                                     
            
                                    </div>
            
            
                                    
                                    <div class="form-group" *ngIf="date_flag==false">
                                        <label for="picker4">Booking Dates<span style="color: #ff0000;">*</span></label>
            
                                        <mat-form-field style="width: 100%;">
            
                                        </mat-form-field>
                                    </div>
            
                                    <div class="form-group" *ngIf="date_flag==true">
                                        <label for="checkIn">Check In</label>
                                    </div>
                                    <div class="form-group" *ngIf="date_flag==true">
                                        <label for="checkOut">Check Out</label>
                                      
                                    </div>
                                    <div class="total-amount">
                                        <h5>Total Amount</h5>
            
                                    </div>
                                    <div class="row">
                                        <div class="col-8 text-left font-weight:bold">
            
                                            1 Days
                                        
                                        </div>
                                        <div class="col-4 text-right ">
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-8 text-left font-weight:bold">
                                            GST
                                        </div>
                                        <div class="col-4 text-right">
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-8 text-left font-weight:bold">
                                            Security Amount (refundable)
                                        </div>
                                        <div class="col-4 text-right">
                                        </div>
                                    </div>
                                    <div class="row mt-1">
                                    
                                    <p class="text-muted mt-1 " style="text-align: center;" >Tax & Charges Applicable</p>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
            
                    <br>
            
                    <div class="row">
                        <div class="col-8">
                            <div class="row included-excluded">
                                <div class="col-12">
                                    <h5 style="font-weight: bold;">Included and Excluded</h5>
                                </div>
                            </div>
                            <br>
                            <div style="display: flex; justify-content: space-between; align-items: center;">
                                <span *ngIf="booking_data[0]['is_parking'] === 'YES'; else parkingNo">✔️ Parking</span>
                                <ng-template #parkingNo>Parking X</ng-template>
                            </div>
            
                            <div style="display: flex; justify-content: space-between; align-items: center;">
                                <span *ngIf="booking_data[0]['is_stage_set'] === 'YES'; else stageSetNo">✔️ Stage Set</span>
                                <ng-template #stageSetNo>Stage Set X</ng-template>
                            </div>
            
                            <div style="display: flex; justify-content: space-between; align-items: center;">
                                <span *ngIf="booking_data[0]['is_ground'] === 'YES'; else groundNo">✔️ Ground</span>
                                <ng-template #groundNo>Ground X</ng-template>
                            </div>
                            <br>
            
                        </div>
                        <div class="col-4">
                            
                        </div>
                    </div>
                </div> -->
            </div>



        </div>
    </div>
</div>